import { IFRAME_BASE_URL } from './constants';

/**
 * Resolves the base URL for embedded portal pages.
 * Prefers the `REACT_APP_PORTAL_PAGES_URL` env var (configurable per environment),
 * falling back to the known production URL. Any trailing slash is normalized off.
 */
function getBaseUrl() {
	const configured = process.env.REACT_APP_PORTAL_PAGES_URL || IFRAME_BASE_URL;
	return configured.endsWith('/') ? configured.slice(0, -1) : configured;
}

/**
 * Builds a Phase 2 embedded iframe URL for the given endpoint.
 * The active login token is always appended as `loginToken`.
 *
 * @param {string} endpoint - Endpoint name (e.g. 'spRequests', 'cpAccountManagement').
 * @param {Object} [params] - Additional query params (e.g. { locationID: 21046 }). Nullish values are skipped.
 * @returns {string} The fully-qualified iframe URL.
 */
export function buildIframeUrl(endpoint, params = {}) {
	const loginToken = window.localStorage.getItem('wilsonnc_token') || '';
	const query = new URLSearchParams({ loginToken });
	Object.entries(params).forEach(([key, value]) => {
		if (value != null) query.append(key, value);
	});
	return `${getBaseUrl()}/${endpoint}?${query.toString()}`;
}
